import {
  GetStoresInput,
  useStoresV2Query,
} from "../../../api/backend/backend-api"

export const useStores = (options: GetStoresInput) => {
  const { data, loading } = useStoresV2Query({
    variables: {
      input: options,
    },
  })
  return {
    loading,
    data: data?.storesV2 ?? [],
  }
}
